import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function ExpandIcon({ color, textSize, type }) {
  return <Icon
    type={type}
    name="fa-expand"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

ExpandIcon.defaultProps = {
  color: colors.gray9,
  textSize: '1rem',
  type: 'fa-regular',
};

export default ExpandIcon;
